<!--
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2022-05-12 23:34:33
 * @LastEditTime: 2023-12-27 21:57:18
 * @Description: 个人信息
 * @
 * @Copyright (c) 2023 by yubaolee | ahfu~ , All Rights Reserved. 
-->
<template>
  <el-menu class="navbar" mode="horizontal">
    <div class="logo">
      <img class="user-avatar" :src="logoHzqf" />衡州企服运营后台
    </div>
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <div class="nav-fullScreen-tab" v-show="showfullScreenState">
      <div :class="['tab-item', selectTab == 'platform' ? 'select_tab' : '']" @click="handleTabChange('platform')">
        平台统计
      </div>
      <div :class="['tab-item', selectTab == 'monitor' ? 'select_tab' : '']" @click="handleTabChange('monitor')">
        企业监测
      </div>
      <div :class="['tab-item', selectTab == 'enterprise' ? 'select_tab' : '']" @click="handleTabChange('enterprise')">
        企业统计
      </div>
    </div>
    <div class="nav-fullScreen" v-show="showfullScreenState">
      <!-- <el-select v-if="selectTab == 'enterprise'" v-model="industryValue" class="customSelect" filterable
        placeholder="请选择行业" @change="handleIndustryChange" size="mini" style="margin-right: 10px;" clearable>
        <template #prefix>
          <i class="el-icon-search" style="color: #fff;"></i>
        </template>
        <el-option v-for="item in industryOptions" :key="item.pId" :label="item.name" :value="item.name">
        </el-option>
      </el-select> -->
      <el-select v-if="selectTab == 'monitor'" v-model="monthValue" class="customSelect" filterable placeholder="请选择月份"
        @change="handleMonthChange" size="mini" style="margin-right: 10px;">
     
        <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <!-- <el-button plain class="fullScreen-button" icon="el-icon-full-screen" @click="handleFullScreen"
        size="mini">全屏</el-button> -->
    </div>
    <el-dropdown
      class="avatar-container"
      @command="handleCommand"
      trigger="click"
    >
      <div class="avatar-wrapper">
        欢迎您， {{ name }}
        <el-badge class="mark" :value="msgcount" />
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item command="handleGoProfile">
          <span>个人中心</span>
        </el-dropdown-item>
        <el-dropdown-item>
          <span
            >切换主题
            <el-switch
              :active-value="1"
              :inactive-value="0"
              style="margin-left: 5px"
              v-model="theme"
          /></span>
        </el-dropdown-item>
        <el-dropdown-item command="logout" divided>
          <span>退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Hamburger from "@/components/Hamburger";
import logo from "@/assets/nqztLogo.png?imageView2/1/w/80/h/80";
import logoHzqf from "@/assets/hzqfLogo.png";
import * as sysMessages from "@/api/sysmessages";
import { GetResources } from "@/api/roles.js"
import {
  getIndustryTreeData
} from "@/api/sn_panel_chart.js";

export default {
  data: function () {
    return {
      logo: logo,
      logoHzqf: logoHzqf,
      theme: 1,
      msgcount: 0,
      showfullScreenState: false,
      selectTab: "platform",
      industryValue: null,
      industryOptions: [],
      monthValue: 6,
      monthOptions: [
        {
          value: 3,
          label: "近3个月",
        },
        {
          value: 6,
          label: "近6个月",
        },
        {
          value: 12,
          label: "近1年",
        },
      ],
    };
  },
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "isIdentityAuth", "name", "themeStatus"]),
  },
  watch: {
    theme() {
      this.toggleClass(document.body, "custom-theme");
    },
    "$route.path": {
      handler: function (newVal, oldVal) {
        if (newVal == "/dashboard") {
          this.showfullScreenState = true;
          this.selectTab = "platform";
          this.$store.state.app.fullScreenTabPageName = "platform";
        } else {
          this.showfullScreenState = false;
        }
      },
      deep: true,
    },
    "$store.state.app.fullScreenTabPageName": {
      handler(newVal) {
        this.selectTab = newVal;
        // if (newVal == "enterprise") {
        //   this.selectTab = true;
        // } else if (newVal == "platform") {
        //   this.selectTab = false;
        // }else if (newVal == "monitor") {
        //   this.selectTab = false;
        // }
      },
    },
  },
  mounted() {
    // GetResources().then(res => {
    //   let data  = res.result || []
    //   if(data.length) {
    //     if(data.findIndex(item => item.name == '企业监测') != -1) {
    //       this.isShowMonitor = true
    //     }
    //     if(data.findIndex(item => item.name == '平台统计') != -1) {
    //       this.isShowPlt = true
    //     }
    //     if((data.findIndex(item => item.name == '企业统计') == -1) && 
    //       (data.findIndex(item => item.name == '企业监测') == -1) &&
    //       (data.findIndex(item => item.name == '平台统计') == -1))
    //     {
    //       this.isHide = true
    //       this.$router.push('/profile')
    //     }
    //   } else {
    //     this.isHide = true
    //     this.$router.push('/profile')
    //   }
    // })
    if (this.$route.path == "/dashboard") {
      this.showfullScreenState = true;
    } else {
      this.showfullScreenState = false;
    }
    this.theme = Number(this.themeStatus);
    this.toggleClass(document.body, "custom-theme");
    sysMessages
      .getList({
        page: 1,
        limit: 20,
        status: 999, //999为全部，0为未读，1为已读
        key: undefined,
      })
      .then((response) => {
        this.msgcount = response.count;
      });
  },
  methods: {
    ...mapActions(["signOutOidc", "saveTheme"]),
    toggleClass(element, className) {
      if (!element || !className) {
        return;
      }
      let classString = element.className;
      const nameIndex = classString.indexOf(className);
      if (nameIndex === -1) {
        classString += "" + className;
      } else if (this.theme !== 1) {
        classString =
          classString.substr(0, nameIndex) +
          classString.substr(nameIndex + className.length);
      }
      element.className = this.theme === 1 ? classString : "";
      this.saveTheme(this.theme);
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      if (this.isIdentityAuth) {
        this.signOutOidc();
      } else {
        this.$store.dispatch("LogOut").then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      }
    },
    handleGoProfile() {
      this.$router.push("/profile");
    },
    handleCommand(name) {
      if (!name) return;
      this[name]();
    },
    handleFullScreen() {
      document.documentElement.requestFullscreen();
      this.$store.state.app.fullScreenState = true;
    },
    handleTabChange(val) {
      this.selectTab = val;
      // if (val == "enterprise") {
      //   this.selectTab = true;
      // } else if (val == "platform") {
      //   this.selectTab = false;
      // }
      this.$store.state.app.fullScreenTabPageName = val;
    },
    handleIndustryChange() {
      if (this.industryValue) {
        this.$store.state.app.industryValue = this.industryValue;
      } else {
        this.$store.state.app.industryValue = "";
      }
    },

    getIndustryOptions() {
      getIndustryTreeData().then(res => {
        this.industryOptions = JSON.parse(res.Data)
      })
    },
    handleMonthChange() {
      this.$store.state.app.monthValue = this.monthValue;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .customSelect .el-input__inner {
  background-color: transparent;
  /* 例如：#f5f7fa 或者 rgba(0, 0, 0, 0.1) */
  color: #fff;
}

.nav-fullScreen {
  position: absolute;
  right: 13rem;
  display: inline-block;

  .fullScreen-button {
    background-color: transparent;
    color: #fff;

    &:hover {
      background-color: transparent;
    }
  }
}

.nav-fullScreen-tab {
  position: absolute;
  left: 285px;
  bottom: -1px;
  width: 268px;
  height: 30px;
  display: flex;
  justify-content: space-between;

  .tab-item {
    font-weight: 500;
    font-size: 0.875rem;
    color: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    background-color: #333;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
    user-select: none;
  }
}

.ml12 {
  margin-left: 0.75rem;
}

.select_tab {
  background-color: #fff !important;
  color: #0f87f6 !important;
}
</style>